import React, {Fragment} from "react";
import QueryBuilder from "./QueryBuilder/QueryBuilder";
import Targets from "./Targets";

export type QueryFieldsType = {
    name: string,
    label: string,
    operators: {
        name: string,
        label: string,
        valueEditor: (props) => any,
    }[]
}[];

export type AbstractFilterProps = {
    value?: any,
    name: string,
    component: string,
    saveChanges: (field: string, value: any) => void,
    queryFields: QueryFieldsType
};

export class AbstractFilter extends React.Component<AbstractFilterProps, any> {

    constructor(props) {
        super(props);
        if (!this.props.value) {
            this.props.saveChanges(this.props.name, {
                filters: [],
                operator: "OR"
            });
        }
    }


    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!this.props.value) {
            this.props.saveChanges(this.props.name, {
                filters: [],
                operator: "OR"
            });
        }
    }

    render() {
        const filter = JSON.parse(JSON.stringify(this.props.value || {
            filters: [],
            operator: "OR"
        }));
        const paramsProps = {
            name: this.props.name,
            value: filter,
            saveChanges: (field, value) => {
                this.props.saveChanges(field, value);
            }
        };
        return (
            <Fragment>
                <label className="control-label">Feltétel</label>
                <div className="row">
                    <div className="col-md-12">
                        <QueryBuilder
                            opened={true}
                            {...paramsProps}
                            fields={this.props.queryFields}
                            component={this.props.component}
                        />
                    </div>
                </div>
                <div className="form-group">
                    <div className="form-control">
                        {
                            !this.props.dirty
                            ?
                            <Fragment><b><Targets {...this.props} /></b> Feliratkozó van a feltételeknek megfelelően</Fragment>
                            :
                            <Fragment>Kérlek, mentsd el a feliratkozottak megtekintéséhez!</Fragment>
                        }
                    </div>
                </div>
            </Fragment>
        );
    }
}